export default  function convertTimestampToDate(timestamp) {
   
    const date = new Date(timestamp * 1000); 

    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');

    
    return `${year}-${month}-${day}`;

}

export  function convertTimestampTofivedays(timestamp,dayCount){
    


  
    
    let date = new Date(timestamp * 1000);

    
    date.setTime(date.getTime() + (dayCount * 24 * 60 * 60 * 1000));

    
    let formattedDate = date.getFullYear() + '-' + 
                        ('0' + (date.getMonth() + 1)).slice(-2) + '-' + 
                        ('0' + date.getDate()).slice(-2) + ' ' + 
                        ('0' + date.getHours()).slice(-2) + ':' + 
                        ('0' + date.getMinutes()).slice(-2) + ':' + 
                        ('0' + date.getSeconds()).slice(-2);

    console.log("formattedDate", formattedDate);
    return formattedDate; 



}

export function convertDDMMYYtoFivedays(timestamp,daycount)
{
  
let date = new Date(timestamp);


date.setDate(date.getDate() +daycount);


let day = String(date.getDate()).padStart(2, '0'); 
let month = String(date.getMonth() + 1).padStart(2, '0'); 
let year = date.getFullYear();


let formattedDate = `${day}-${month}-${year}`;
return formattedDate


}

export  function stripHtmlTags (html)  {
  return html.replace(/<[^>]+>/g, ''); 
};

/**
 * Turns a name into a URL-safe slug part: letters (any language) and digits
 * are kept, everything else ("&", "'", "/", spaces...) becomes a single "-".
 * Same rule as toSlugPart in Sthanickbackend/src/controller/seoController.js -
 * keep the two in sync.
 */
export function toSlugPart(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^\p{L}\p{M}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildShopPath(shop) {
  const addressCity = String(shop?.address || "")
    .split(",")
    .map((part) => part.trim())
    .find((part) => part.length > 0);

  const city = toSlugPart(shop?.city || shop?.location || addressCity);

  const categoryName =
    shop?.categories?.[0]?.name ||
    shop?.categories?.[0]?.description ||
    shop?.listCategories?.[0]?.name ||
    shop?.listCategories?.[0]?.description ||
    shop?.description ||
    "";
  const category = toSlugPart(categoryName);

  const slugName = toSlugPart(shop?.shopName || shop?.shop_name || shop?.name);
  const id = shop?.id || shop?.vendor_id || shop?.vendorId || "unknown";
  const slug = slugName ? `${slugName}-${id}` : String(id);

  return `/shop/${city || "unknown"}/${category || "unknown"}/${slug}`;
}

export function buildListingShopPath(shop) {
  const city = toSlugPart(shop?.location || shop?.city) || "unknown";
  const categoryName =
    shop?.listing?.name ||
    shop?.listingName ||
    shop?.category ||
    shop?.description;
  const category = toSlugPart(categoryName) || "unknown";
  const shopName = toSlugPart(shop?.shopName || shop?.shop_name || shop?.name);
  const id = shop?.id || shop?.vendor_id || "unknown";
  const slug = shopName ? `${shopName}-${id}` : String(id);

  return `/vendorshop/${city}/${category}/${slug}`;
}

export function getGreeting() {
  const now = new Date();
  const hours = now.getHours();

  if (hours < 12) {
    return "Good morning";
  } else if (hours < 18) {
    return "Good afternoon";
  } else {
    return "Good night";
  }
}

export function getDate(){
    const now = new Date();
    
    // Format the date
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = now.toLocaleDateString('en-US', options);
    
    // Get the time
    const formattedTime = now.toLocaleTimeString('en-US', { hour12: false });
    
    return { formattedDate, formattedTime };
  }








